import { defaultBtnColorOptions } from '../const/defaultBtnColorOptions';
import { getProjectId } from '../helpers/helpers';

export function getStyleSheetMarker(andFlag?: boolean) {
    return '.alan-' + getProjectId() + (andFlag ? '' : ' ');
}

export function generateKeyFrame(name, rule) {
    var prefixes = ['@-webkit-keyframes', '@keyframes'];
    var r = '';
    for (var i = 0; i < prefixes.length; i++) {
        r += prefixes[i] + ' ' + name + '{' + rule + '} ';
    }
    return r;
}

export function mergeOptionsForStyleSheet(webOptions) {
    var predefinedBtnColorOptions = defaultBtnColorOptions;

    if (webOptions?.btnOptions) {
        if (webOptions?.btnOptions.btnLayerOptions) { //old settings
            predefinedBtnColorOptions = defaultBtnColorOptions;
        } else {
            predefinedBtnColorOptions = webOptions?.btnOptions ? { ...defaultBtnColorOptions, ...webOptions?.btnOptions } : defaultBtnColorOptions;
        }
    }

    return predefinedBtnColorOptions;
}